/** Registre maître — Contenu officiel (source de vérité unique). Valeurs par défaut + chargement public. */
import { useEffect, useState } from "react";
import axios from "axios";
import { PUBLIC_ORIGIN } from "./domain";

export const OFFICIAL_DEFAULTS = {
  institute_name: "Institut Impact Élite Martial",
  network_name: "Réseau Kaizen",
  system_name: "Kaizen System",
  event_name: "Jeux Martiaux Inter-Écoles — Institut Impact Élite Martial",
  event_title: "Jeux Martiaux Inter-Écoles",
  event_subtitle: "Institut Impact Élite Martial",
  event_signature: "Événement de développement compétitif encadré par le Réseau Kaizen.",
  event_location: "Institut Impact Élite Martial, Val-d'Or",
  event_date_label: "14 novembre 2026",
  event_tagline: "Compétition. Contrôle. Stratégie. Progression.",
  event_tagline_sub: "Une expérience compétitive structurée pour développer la technique, l'endurance et l'intelligence de combat.",
  event_positioning: "",
  safety_message: "La sécurité de l'athlète prime toujours sur le résultat. La victoire se construit par la technique, la stratégie et le pointage — jamais par la recherche du knockout.",
  scoring_rules_striking: [],
  scoring_rules_bjj: [],
  bjj_public_text: "",
  rules_format_note: "Format interne de développement compétitif.",
  disciplines: {
    muay_thai_educatif: "Kickboxing/Muaythai",
    jjb: "Jiu-Jitsu brésilien compétitif encadré",
    can_ryu_demo: "Jiu-Jitsu Can Ryu — démonstration",
    petits_samourais: "Petits Samouraïs — parcours (3-6 ans)",
  },
  trial_price: 19.98,
  trial_label: "Cours d'essai — 19,98 $",
  trial_description: "Première séance encadrée permettant de découvrir l'entraînement, le fonctionnement du dojo et le programme adapté à votre objectif.",
  phone: "819-527-9446",
  email: "impactkb.bjj@gmail.com",
  booking_url: `${PUBLIC_ORIGIN}/cours-essai`,
  registration_url: "",
  rules_url: `${PUBLIC_ORIGIN}/reglement-securite`,
  event_address: "1218, 7e Rue, Val-d'Or (Québec) J9P 5S7",
  suspension_status_label: "Inscriptions temporairement suspendues — validation finale de sécurité et d'organisation en cours.",
  suspension_public_message: "Les inscriptions sont temporairement suspendues pendant la finalisation des validations de sécurité et d'organisation. Les informations officielles seront publiées lorsque le processus sera complété.",
  temporary_official_text: "Projet interne de développement compétitif et technique.",
};

export const DISCIPLINE_LABELS = OFFICIAL_DEFAULTS.disciplines;
export const DISCIPLINE_EMOJI = { muay_thai_educatif: "🥊", kickboxing_educatif: "🥊", jjb: "🥋", can_ryu_demo: "🎎", petits_samourais: "🐣" };
export const disciplineLabel = (id, terms) => ((terms || OFFICIAL_DEFAULTS).disciplines || {})[id] || DISCIPLINE_LABELS[id] || id;

let _cache = null;
let _promise = null;
export function loadOfficialTerms() {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/official-terms`)
      .then((r) => { _cache = { ...OFFICIAL_DEFAULTS, ...r.data }; return _cache; })
      .catch(() => OFFICIAL_DEFAULTS);
  }
  return _promise;
}

export function useOfficialTerms() {
  const [terms, setTerms] = useState(_cache || OFFICIAL_DEFAULTS);
  useEffect(() => { let on = true; loadOfficialTerms().then((t) => on && setTerms(t)); return () => { on = false; }; }, []);
  return terms;
}

export const priceFr = (v) => `${Number(v ?? 19.98).toFixed(2).replace(".", ",")} $`;
